const state = {
  isThermal: false,
  isBobbieContext: false,
  bobbieToken: null,
  isInIFrameContext: false,
  isEmployee: false,
  isSampleProject: false,
  roles: [],
};

const getters = {
  activeUserIsEmployee: (state) => state.isEmployee,
  isSampleProject: (state) => state.isSampleProject,
  roles: (state) => state.roles,
};

const actions = {};

const mutations = {
  setIsThermal(state, value) {
    state.isThermal = value;
  },
  setIsBobbieContext(state, value) {
    state.isBobbieContext = value;
  },
  setBobbieToken(state, token) {
    state.bobbieToken = token;
  },
  setIsInIFrameContext(state, value) {
    state.isInIFrameContext = value;
  },
  setIsEmployee(state, value) {
    state.isEmployee = value;
  },
  setIsSampleProject(state, value) {
    state.isSampleProject = !!value;
  },
  setRoles(state, roles) {
    state.roles = Array.isArray(roles) ? roles : [];
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
